module.exports = __webpack_public_path__ + "5e75c678391d787696bb192db689fcaf.woff2";